export const theme = {
    color: {
        black: "#000",
        concrete: "#f2f2f2",
        silver: "#ccc",
        silverChalice: "#a6a6a6",
        white: "#fff",
        crimson: "#dc143c",
    },
    breakpoint: {
        mobileMax: 768,
    },
};